import CryptoJS from 'crypto-js';

const enc = 'dHJhbnN2b2ljZXdlYkAxMjM0NTY3OA==';
const SALT = window.atob(enc);

const sha512 = (password, salt) => {
  const hash = CryptoJS.HmacSHA512(password, salt);
  const value = hash.toString(CryptoJS.enc.Hex);
  return {
    salt,
    passwordHash: value,
  };
};

export default function generateHashPassword(plainTextPassword) {
  const passwordData = sha512(plainTextPassword, SALT);
  return passwordData.passwordHash;
}
